import React from 'react';
import Button from '@mui/material/Button';
import ItemFormModal from './ItemFormModal';
import { Box, FormHelperText } from '@mui/material';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const AddLineItemButton = ({
  errors,
  addItem,
  buttonText,
  name = 'document_lines',
  lineItems,
  invoiceTypeCode,
  profileExecutionId,
  restrictToRcm = false,
}) => {
  const { eInvoiceForm } = useTranslatedMessages();
  const resolvedButtonText = buttonText ?? eInvoiceForm.add_line_item_button.button_text;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = (data) => {
    addItem({ ...data, key: data?.key || Date.now() });
    handleClose();
  };
  return (
    <React.Fragment>
      <Box display="flex" alignItems="center" gap={1}>
        <Button id="add-line-item" variant="contained" onClick={handleOpen}>
          {resolvedButtonText}
        </Button>
        {errors[name] && (
          <FormHelperText error sx={{ m: 0 }}>
            {errors[name]?.message}
          </FormHelperText>
        )}
      </Box>
      <ItemFormModal
        open={open}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        invoiceTypeCode={invoiceTypeCode}
        profileExecutionId={profileExecutionId}
        restrictToRcm={restrictToRcm}
      />
    </React.Fragment>
  );
};

export default AddLineItemButton;
